export default {
    primaryColor: '#FF9201',
    secondaryColor: '#2B2B24',
    thirdColor: '#010101'
}